import { CaseStatusEnum, type WarningCaseStatus } from '@/citator/schema/case-status-schema'

const kCaseStatusIndicatorOrder: WarningCaseStatus[] = [CaseStatusEnum.likely_bad, CaseStatusEnum.overruling_risk, CaseStatusEnum.caution]

/** Each warning treatment's dot color, and the label screen readers hear in its place. */
export const kCaseStatusIndicatorDots: Record<WarningCaseStatus, { colorClass: string; label: string }> = {
  [CaseStatusEnum.likely_bad]: { colorClass: 'bg-red-500', label: 'negative treatment' },
  [CaseStatusEnum.overruling_risk]: { colorClass: 'bg-orange-400', label: 'overruling risk' },
  [CaseStatusEnum.caution]: { colorClass: 'bg-yellow-500', label: 'use caution' },
}

const kTreatmentListFormat = new Intl.ListFormat('en', { type: 'conjunction' })

/** The warning treatments present in a list of case statuses, one each, most severe first. */
export function getCaseStatusIndicatorStatuses(caseStatuses: ReadonlyArray<string | null | undefined>): WarningCaseStatus[] {
  return kCaseStatusIndicatorOrder.filter((status) => caseStatuses.includes(status))
}

/**
 * Names the treatments the dots stand for (e.g. "negative treatment and use caution"), since the
 * dots themselves are hidden from screen readers.
 */
export function getCaseStatusIndicatorsLabel(caseStatuses: ReadonlyArray<string | null | undefined>): string | null {
  const statuses = getCaseStatusIndicatorStatuses(caseStatuses)
  return statuses.length > 0 ? kTreatmentListFormat.format(statuses.map((status) => kCaseStatusIndicatorDots[status].label)) : null
}
